import React from 'react';
import { CodeProps } from '@dreamai/types';

/**
 * Custom Code component for our DSL
 */
const CodeComponent: React.FC<CodeProps> = ({ value, language, ...props }) => {
  return (
    <pre {...props}>
      <code className={language ? `language-${language}` : ''}>{value}</code>
    </pre>
  );
};

export default CodeComponent;
